<template>
    <v-dialog max-width="850" v-model="dialog">
        <template #activator="{on}">
            <v-btn v-on=on v-if='$can("price", "Product")' class="mr-2">{{ product ? 'Edit product' : 'Add single product'}}</v-btn>
        </template>
        <v-card>
            <v-card-title>{{ product ? 'Edit product' : 'Add single product'}}</v-card-title>
            <v-card-text>
                <v-alert v-if="error" border="bottom" color="red" dismissible type="error">
                    <div v-for="(msg,idx) in errors" :key="'_msg_'+idx">{{msg}}</div>
                </v-alert>
                <v-row>
                    <v-col cols="12">
                        <v-text-field v-model="model.name" label="Name" @change="generateSku"></v-text-field>
                        <v-text-field v-model="model.code" label="Code" hint="Leave empty to asign code automatically"></v-text-field>
                        <v-text-field v-model="model.sku" label="Sku"></v-text-field>
                        <brand v-model="model.brand" label="Brand"></brand>
                        <product-type v-model="model.type" label="Type"></product-type>
                        <v-text-field v-model="model.low_stock_limit" label="Low stock limit"></v-text-field>
                    </v-col>
                </v-row>
                <template v-if="!product">
                    <v-row v-for="catalog in catalogs" v-bind:key="'_catalog_'+catalog.id">
                        <v-col cols="12">
                            <v-card >
                                <v-card-title>
                                    {{catalog.name}}
                                    <v-spacer />
                                    <v-btn color="white" @click="toggleToCatalog(catalog.id)">{{isInCatalog(catalog.id) ? 'Remove from catalog':'Add to catalog'}}</v-btn>
                                </v-card-title>
                                <v-card-text v-if="isInCatalog(catalog.id)">
                                    <v-row>
                                        <v-col v-for="currency in currencies" :key="'_curr_'+currency.id">
                                            <v-text-field v-model="productCatalog(catalog.id).prices[currency.currency]" :label="currency.currency"></v-text-field>
                                        </v-col>
                                    </v-row>
                                </v-card-text>
                            </v-card>
                        </v-col>
                    </v-row>
                </template>
            </v-card-text>
            <v-card-actions>
                <v-spacer />
                <v-btn color="primary" @click="save">{{ product ? 'Save product' : 'Add single product'}}</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import ProductType from '../forms/autocomplete/ProductType.vue'
import Brand from "../forms/select/Brand.vue"
import { mapActions, mapGetters } from 'vuex'
export default {
    components:{
        ProductType,
        Brand
    },
    props: {
        product: {
            type: Object,
            default: null
        }
    },
    data: () => ({
        model: {
            catalogs:[],
            name:null,
            sku:null
        },
        carousel:null,
        dialog:false,
        error:false,
        errors:[]
    }),
    computed:{
        ...mapGetters("catalogs",["catalogs"]),
        ...mapGetters("currencies",["currencies"]),
        productCatalog:function(){
            return (catalogId) => this.model.catalogs.find(c => c.catalog_id == catalogId)
        }
    },
    mounted () {
        if (this.product) {
            this.model.name = this.product.name
            this.model.code = this.product.code
            this.model.sku = this.product.sku
            this.model.brand = this.product.brand
            this.model.type = this.product.type
            this.model.low_stock_limit = this.product.low_stock_limit

        }
    },
    methods:{
        ...mapActions("products",["create", 'update']),
        ...mapActions("app",["displaySnackBar"]),
        isInCatalog(catalogId){
            return this.model.catalogs.find(c => c.catalog_id== catalogId)
        },
        toggleToCatalog(catalogId){
            if(this.isInCatalog(catalogId)){
                this.model.catalogs = this.model.catalogs.filter(c => c.catalog_id != catalogId)
            }else{
                this.model.catalogs.push({catalog_id:catalogId, prices:{}})
            }
        },
        save(){
            this.errors = []
            this.error = false
            let promise = null
            if(this.product) {
                this.model.id = this.product.id
                promise = this.update({ model : this.model })
            } else {
                promise = this.create(this.model)
            }
            promise.then((data) => {
                this.displaySnackBar({text:data.message, color:'green darken-3'})
                this.dialog=false
                if(this.product) {
                    this.$emit('update')
                }else{
                    this.$router.push("/products/view/" + data.product.id);
                }
            })
            .catch((data) => {
                this.errors.push(data.message);
                if(data.errors){
                    Object.entries(data.errors).forEach((msg) => this.errors.push(msg[1][0]));
                }
                this.error = true;
            })
        },
        generateSku(){
            if(!this.model.sku){
                let sku = this.model.name;
                sku = sku.toUpperCase();
                sku = sku.replace(/\s/g,'')
                this.model.sku = sku
            }
        }
    }
}
</script>

<style>

</style>